@if (item.navCap) {
<div mat-subheader class="nav-caption">
  {{ item.navCap }}
</div>
}
@if (!item.navCap && !item.external && !item.twoLines) {
@if (!item.children || !item.children.length) {
<a appSidebarNavItemStatus [routerLink]="item.route" [href]="item.route" (click)="onItemSelected($event, item)"
  [ngClass]="{ 'mat-list-item': true, 'menu-list-item': true, disabled: item.disabled }"
  (isExpanded)="expanded = $event" [item]="item"
  style="display: flex; align-items: center; text-decoration: none; min-height: 48px; padding: 0 16px; border-radius: 4px;">
  <i-tabler name="{{ item.iconName }}" class="routeIcon mat-list-item-icon" style="margin-right: 16px;"></i-tabler>
  <span class="hide-menu">{{ getTranslatedItem(item.displayName) }}</span>
  @if (item.chip) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
  </span>
  }
</a>
} @else {
<div appSidebarNavItemStatus (click)="onItemSelected($event, item)"
  [ngClass]="{ 'mat-list-item': true, 'menu-list-item': true, disabled: item.disabled }"
  (isExpanded)="expanded = $event" [item]="item"
  style="display: flex; align-items: center; text-decoration: none; min-height: 48px; padding: 0 16px; border-radius: 4px; cursor: pointer;">
  <i-tabler name="{{ item.iconName }}" class="routeIcon mat-list-item-icon" style="margin-right: 16px;"></i-tabler>
  <span class="hide-menu">{{ getTranslatedItem(item.displayName) }}</span>
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon class="callout" [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
  @if (item.chip) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
  </span>
  }
</div>
}
}

<!-- external Link -->
@if (!item.customLogoPath) {
@if (!item.navCap && item.external) {
<mat-list-item (click)="openExternalLink(item.route, item.blank)" class="menu-list-item" [matTooltip]="item.tooltip"
  matTooltipPosition="right">
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <span class="hide-menu">{{ item.displayName | translate }}</span>
</mat-list-item>
}
} @else {
@if (!item.navCap && item.external) {
<mat-list-item (click)="openExternalLink(item.route, item.blank)" class="menu-list-item custom_external_link"
  [ngClass]="item.accentColor && 'has_accent'" [style.border-color]="item.accentColor ?? '#fff'"
  [matTooltip]="item.tooltip" matTooltipPosition="right">
  <span matListItemIcon class="custom_logo" [style.background-image]="'url(' + item.customLogoPath + ')'"></span>
  <div matListItemLine class="hide-menu custom_text">
    @for (text of item.customDisplayName; track $index) {
    <span [style.color]="text.accent && item.accentColor">{{text.value}}</span>
    }
  </div>
  <i-tabler class="routeIcon m-l-0" name="{{ item.iconName }}" matListItemMeta></i-tabler>
</mat-list-item>
}
}




<!-- children -->
<div [@expandCollapse]="expanded ? 'expanded' : 'collapsed'" class="childMenu">
  @for (child of item.children; track child) {
  <app-nav-item [item]="child" (notify)="notify.emit()" [depth]="depth + 1" [style.--depth]="depth + 1">
  </app-nav-item>
  }
</div>